import * as React from 'react';

const CARD_SELECTOR = '.manage-activities-v2 .pack-card'

// Call the returned function just before a layout switch; afterwards the card that was at the top
// of the screen is scrolled back to the same spot instead of the page clamping to the footer.
export function useTopCardHeldInPlace(layoutKey: string) {
  const anchorRef = React.useRef<{ cardId: string, top: number } | null>(null)

  React.useLayoutEffect(() => {
    const anchor = anchorRef.current
    anchorRef.current = null
    if (!anchor) { return }
    // looked up again by id because a switch like Group by rebuilds every card
    const element = Array.from(document.querySelectorAll<HTMLElement>(CARD_SELECTOR)).find(card => card.dataset.cardId === anchor.cardId)
    if (!element) { return }
    window.scrollBy(0, element.getBoundingClientRect().top - anchor.top)
  }, [layoutKey])

  return function rememberTopCard(): string | null {
    // cards above the screen or behind the sticky filters bar are out of view; the bar is measured since it
    // grows when its filters wrap, and it scrolls away on narrow or short screens where it is not sticky
    const filtersBottom = document.querySelector('.manage-activities-v2-filters')?.getBoundingClientRect().bottom ?? 0
    const hiddenAbove = Math.max(filtersBottom, 0)
    const cards = Array.from(document.querySelectorAll<HTMLElement>(CARD_SELECTOR))
    const element = cards.find(card => card.getBoundingClientRect().bottom > hiddenAbove)
    // a teacher still at the first card stays at the top of the list rather than following it
    const keepsPlace = element && element !== cards[0] && element.dataset.cardId
    anchorRef.current = keepsPlace ? { cardId: element.dataset.cardId, top: element.getBoundingClientRect().top } : null
    return anchorRef.current?.cardId ?? null
  }
}
